module.exports = "/assets/data/0983474114ad95a9a3bddd9a2decd886-BB12.data.json";